import React from 'react';
import { CountdownTimer } from './CountdownTimer';
import { PricingSection } from './PricingSection';
import { Shield, Lock, CreditCard } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-20 bg-beige border-t border-beige-dark" data-id="element-125">
      <div className="max-w-container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-126">
        <div className="mb-12" data-id="element-127">
          <CountdownTimer data-id="element-128" />
        </div>

        <PricingSection data-id="element-129" />

        <div className="mt-8 flex flex-wrap justify-center items-center gap-6 text-sm font-medium text-gray-600" data-id="element-130">
          <div className="flex items-center gap-2" data-id="element-131">
            <CreditCard className="w-5 h-5 text-gold" data-id="element-132" />
            <span data-id="element-133">Mercado Pago</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-134">
            <Lock className="w-5 h-5 text-gold" data-id="element-135" />
            <span data-id="element-136">Pago 100% seguro</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-137">
            <Shield className="w-5 h-5 text-gold" data-id="element-138" />
            <span data-id="element-139">Garantía 7 días</span>
          </div>
        </div>
      </div>
    </section>;
}